import React, { useContext } from "react";
import Header from "../Components/Header";
import Rightcontainer from "../Components/Rightcontainer";
import { Link } from "react-router-dom";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";

const Support = ({ handleShow }) => {
  const theme = localStorage.getItem("theme");

  // language
  const translations = {
    hi: {
      contact: "नीचे दिए गए प्लेटफ़ॉर्म पर हमसे संपर्क करें।",
      money: "राशि डालें  ",
      next: "आगे बड़े ",
      addAmount: "राशि जोड़ी जानी है ",
      referPerson: "रेफ़रल | ",
    },
    en: {
      contact: "Contact Us At Below Platforms.",
      money: "Enter Amount",
      next: "Next",
      addAmount: "Amount to be added",
      referPerson: "Referral",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme
  const styles = {
    backgroundColor: theme === "light" ? "#fff" : "black",
    color: theme === "light" ? "black" : "#fff",
  };
  const styles1 = {
    color: theme === "light" ? "black" : "white",
  };

  return (
    <div>
      <div className="leftContainer  mb_space pb-0 vh-100" style={styles}>
        <div className="support-hub-container">
          {/* Header Section */}
          <div className="support-banner">
            <div className="banner-image">
              <img src="./images/support.jpg" alt="Support" />
            </div>
            <div className="banner-text">
              <h2 className="animated-heading">Need Help?</h2>
              <p>We're here to help you 24/7</p>
            </div>
          </div>

          <div className="contact-methods-wrapper">
            <div className="section-label" style={{ ...styles1 }}>
              {translations[language].contact}
            </div>

            {/* Support Grid: WhatsApp & Email */}
            <div className="support-grid-modern">
              {/* WhatsApp Card */}
              {JSON.parse(localStorage.getItem("sitSetting"))
                ?.whatsappSupport && (
                <a
                  className="support-card whatsapp-theme"
                  href={
                    JSON.parse(localStorage.getItem("sitSetting"))
                      ?.whatsappSupport
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="card-icon">
                    <img src="/images/whatsapp-new-.png" alt="WhatsApp" />
                  </div>
                  <div className="card-info">
                    <h5>WhatsApp</h5>
                    <span>Chat with us directly</span>
                  </div>
                </a>
              )}

              {/* Email Card */}
              <a
                className="support-card email-theme"
                href="mailto:support@example.com"
              >
                <div className="card-icon">
                  <img src="./images/mail-new.png" alt="Email" />
                </div>
                <div className="card-info">
                  <h5>Email Support</h5>
                  <span>Follow us for updates</span>
                </div>
              </a>
            </div>

            {/* Phone Support Footer Card */}
            <div className="phone-support-strip">
              <div className="strip-content">
                <div className="pulse-icon-container">
                  <img src="/images/phone.png" alt="Phone" />
                </div>
                <div className="strip-text">
                  <p>Get instant help from our team</p>
                  <a
                    href={`tel:${
                      JSON.parse(localStorage.getItem("sitSetting"))
                        ?.CompanyMobile
                    }`}
                    className="phone-link"
                  >
                    {
                      JSON.parse(localStorage.getItem("sitSetting"))
                        ?.CompanyMobile
                    }
                  </a>
                </div>
              </div>
              <div className="call-now-tag">Call Now</div>
            </div>
          </div>
        </div>
      </div>
      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </div>
  );
};

export default Support;
